/* eslint-disable */ 
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import LazyLoad from "vanilla-lazyload";
import Flickity from "flickity";
import inView from "in-view";
import ParallaxElement from "./utils/parallax";

gsap.registerPlugin(ScrollTrigger, SplitText);

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Toggle menu
    const header = document.querySelector(".main-header");
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
          header.classList.add("theme-black");

          if (!HTML.classList.contains("open-menu")) {
            setTimeout(() => {
              window.dispatchEvent(new Event("scroll"));
            }, 300);
          }
        });
      });
    }

    this.carousel();
    this.marquee();
    this.parallax();
    this.textareaResize();
    this.listFestivals();
    this.header();
    this.projects();
    this.txtApparition();
    this.inViewport();
  }

  header() {
    function getContrastYIQ(rgb) {
      rgb = rgb
        .substring(4, rgb.length - 1)
        .replaceAll(" ", "")
        .split(",");
      const yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
      return yiq >= 194 ? "black" : "white";
    }

    const sections = document.querySelectorAll("section");
    const header = document.querySelector(".main-header");
    if (sections) {
      let oldTheme = "";
      window.addEventListener("scroll", () => {
        sections.forEach((section) => {
          const bound = section.getBoundingClientRect();
          const style =
            window.getComputedStyle(section) || section.currentStyle;
          if (
            bound.y -
              Number.parseFloat(style.getPropertyValue("margin-top")) -
              header.offsetHeight / 2 <=
              0 &&
            bound.bottom > 0
          ) {
            let backgroundColor = window
              .getComputedStyle(section, null)
              .getPropertyValue("background-color");

            if (backgroundColor.includes("rgba"))
              backgroundColor = "rgb(255, 255, 255)";

            const theme = `theme-${getContrastYIQ(backgroundColor)}`;
            header.classList.remove("theme-white", "theme-black");
            header.classList.add(theme);

            oldTheme = theme;
          }
        });
      });

      window.dispatchEvent(new Event("scroll"));
    }
  }

  parallax() {
    // Parallax
    if (window.innerWidth > 1022) {
      document.querySelectorAll(".js-parallax").forEach((el) => {
        const _p = new ParallaxElement(el, ".js-parallax", false);
        _p.teardown();
      });
    }
  }

  carousel() {
    const elts = document.querySelectorAll(".carousel");

    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          cellSelector: ".item",
          pageDots: false,
          cellAlign: "left",
          contain: true,
          prevNextButtons: false,
        });

        const next = el.querySelector(".next");
        if (next) {
          next.addEventListener("click", (e) => {
            e.preventDefault();
            const max = Math.round(flkty.size.width / flkty.slidesWidth);
            if (flkty.selectedIndex + max < flkty.cells.length) {
              flkty.next();
            }
          });
        }
        const prev = el.querySelector(".prev");
        if (prev) {
          prev.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.previous();
          });
        }
      });
    }
  }

  txtApparition() {
    const elts = document.querySelectorAll(".txt-apparition");

    if (elts) {
      elts.forEach((el) => {
        const lines = new SplitText(el, {
          type: "lines",
          linesClass: "line",
        });
        el.classList.add("ready");

        lines.lines.forEach((line) => {
          const newLine = document.createElement("span");
          newLine.innerHTML = line.innerHTML;
          line.innerHTML = "";
          line.append(newLine);
        });

        const tween = gsap.to(lines.lines, {
          stagger: 0.1,
          autoAlpha: 1,
          paused: true,
          y: "0rem",
        });

        ScrollTrigger.create({
          trigger: el,
          start: "top 50%",
          end: "bottom 50%",
          onUpdate: (self) => {
            tween.seek(self.progress * tween.duration());
          },
        });
      });
    }
  }

  listFestivals() {
    const elts = document.querySelectorAll(".list-festivals");

    if (elts) {
      elts.forEach((el) => {
        const items = el.querySelectorAll("[data-color]");
        if (items) {
          let current = 0;
          const nav = el.querySelector(".nav .inner");
          const triggers = nav.querySelectorAll("a");
          const cursor = el.querySelector(".cursor .inner");

          window.addEventListener("scroll", () => {
            items.forEach((item, i) => {
              const bound = item.getBoundingClientRect();

              if (
                bound.top <= window.innerHeight / 2 &&
                bound.bottom > window.innerHeight / 2
              ) {
                gsap.to(el, {
                  backgroundColor: item.dataset.color,
                  duration: 0.5,
                });

                //
                if (nav) {
                  gsap.to(nav, { y: `${(i / -items.length) * 100}%` });

                  if (triggers) {
                    triggers[current].classList.remove("active");
                    triggers[i].classList.add("active");
                  }
                }

                //
                if (cursor) {
                  gsap.to(cursor, { y: `${(i / -items.length) * 100}%` });
                }

                current = i;
              }
            });
          });

          window.dispatchEvent(new Event("scroll"));

          if (triggers) {
            triggers.forEach((trigger, i) => {
              trigger.addEventListener("click", (e) => {
                e.preventDefault();

                if (items[i]) {
                  const bound = items[i].getBoundingClientRect();
                  gsap.to(document.querySelectorAll("html, body"), {
                    scrollTop:
                      bound.y +
                      window.scrollY -
                      (window.innerHeight / 2 - bound.height / 2),
                    duration: 0.8,
                    ease: "expo.out",
                  });
                }
              });
            });
          }
        }
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.08,
    });
    inView(".js-reveal:not(.old-content):not(.is-visible")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }

  projects() {
    const elts = document.querySelectorAll(".projects");

    if (elts) {
      elts.forEach((el) => {
        const projects = el.querySelectorAll(".project");
        const links = el.querySelectorAll(".project-link");

        if (projects && links) {
          let current = -1;

          function close() {
            if (links[current]) {
              links[current].classList.remove("active");
              projects[current].classList.remove("active");
            }

            el.classList.remove("open-project");
            current = -1;
          }

          document.body.addEventListener("click", (e) => {
            if (
              !e.target.classList.contains("project") &&
              !e.target.closest(".project") &&
              !e.target.classList.contains("project-link") &&
              !e.target.closest(".project-link")
            ) {
              close();
            }
          });

          window.addEventListener("scroll", () => {
            close();
          });

          projects.forEach((project, i) => {
            project.addEventListener("click", (e) => {
              e.preventDefault();

              el.classList.add("open-project");

              if (links[i]) {
                if (links[current]) {
                  links[current].classList.remove("active");
                  projects[current].classList.remove("active");
                }

                if (i == current) {
                  close();
                  return;
                }

                links[i].classList.add("active");
                projects[i].classList.add("active");
                current = i;
              }
            });
          });
        }

        /// ANIMATION SCROLL
        if (window.innerWidth >= 768) {
          const elOpacity = el.querySelector(".to-opacity-0");
          const elSticky = el.querySelector(".to-sticky");
          const tweenProjects = gsap.from(projects, {
            duration: 0.3,
            autoAlpha: 0,
            y: "14rem",
            stagger: 0.1,
            paused: true,
          });
          // const tweenProjects = gsap.from(projects, {
          //   duration: 0.3,
          //   scale: 0,
          //   stagger: 0.1,
          //   paused: true,
          // });
          // const tweenProjects = gsap.from(projects, {
          //   duration: 0.3,
          //   y: "100vh",
          //   stagger: 0.1,
          //   paused: true,
          // });

          gsap.to(elOpacity, {
            autoAlpha: 0,
            scrollTrigger: {
              trigger: elSticky,
              scrub: true,
              start: "top top",
              end: "bottom top+=60%",
            },
          });
          gsap.to(el.querySelector(".icon--heart"), {
            y: "10%",
            scrollTrigger: {
              trigger: elSticky,
              scrub: true,
              start: "top bottom",
              end: "bottom top+=20%",
            },
          });

          ScrollTrigger.create({
            trigger: el,
            start: "top top",
            end: "bottom bottom",
            onUpdate: (self) => {
              tweenProjects.seek(self.progress * tweenProjects.duration());
            },
            pin: elSticky,
          });
        }
      });
    }
  }

  marquee() {
    const marquees = document.querySelectorAll(".marquee .line");

    if (marquees) {
      let pas = 0.75;

      function wheel(e) {
        const orgin = 0.75;
        pas = (e.deltaY < 0 ? -1 : 1) * orgin;
      }

      window.addEventListener("wheel", wheel);

      window.addEventListener("unmount", () => {
        window.removeEventListener("wheel", wheel);
      });

      marquees.forEach((el) => {
        const flkty = new Flickity(el, {
          cellAlign: "left",
          freeScroll: true,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          draggable: false,
        });

        flkty.request = 0;

        function launch() {
          el.removeEventListener("inview", launch);
          play();
        }
        function play() {
          flkty.x -= Number.parseFloat(el.dataset.dir) * pas;
          flkty.settle(flkty.x);
          flkty.request = window.requestAnimationFrame(play);
        }

        el.addEventListener("inview", launch);
        el.addEventListener("outview", (e) => {
          window.cancelAnimationFrame(flkty.request);
          el.addEventListener("inview", launch);
        });

        window.addEventListener("unmount", () => {
          flkty.destroy();
          window.cancelAnimationFrame(flkty.request);
          el.removeEventListener("inview", launch);
        });
      });
    }
  }

  textareaResize() {
    /**
     * Textarea
     */
    // expand height textarea
    function autoExpand(field) {
      // Reset field height
      field.style.height = "inherit";

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height =
        Number.parseInt(computed.getPropertyValue("border-top-width"), 10) +
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        Number.parseInt(computed.getPropertyValue("border-bottom-width"), 10);

      field.style.height = `${height}px`;
    }

    document.addEventListener("input", (event) => {
      if (event.target.tagName.toLowerCase() !== "textarea") return;
      autoExpand(event.target);
    });
  }
}

window.addEventListener("load", () => {
  new App();
});
